module.exports = __webpack_public_path__ + "static/img/eicad_combination01.85d8e425.png";